import { defineStore } from 'pinia';

export const useAppStore = defineStore('app', {
    state: () => ({
        device: "desktop",
        sidebar: {
            opened: true,
            withoutAnimation: false,
        },
        openMenuIndex: [], // 默认打开的菜单
        pageState: null,
    }),
    actions: {
        toggleSideBar() {
            this.sidebar.opened = !this.sidebar.opened;
            this.sidebar.withoutAnimation = false;
        },
        closeSideBar({ withoutAnimation }) {
            this.sidebar.opened = false;
            this.sidebar.withoutAnimation = !!withoutAnimation;
        },
        toggleDevice(device) {
            this.device = device;
        },
        changeOpenMenu(menuIndex) {
            if (!this.openMenuIndex.includes(menuIndex)) {
                this.openMenuIndex.push(menuIndex);
            }
        },
        changePageState(pageState) {
            this.pageState = pageState;
        }
    }
});